import React from "react"
import "./style.css";

const createMarkup = (data) => {
  if (data) {
    return { __html: data };
  } else {
    return { __html: <p></p> };
  }
}

const AdminAdmissionAlertDetails = ({ data, updateRoutePage }) => {

  const listItems = JSON.parse(data.keydate_activity).map((item, i) =>
    <tr key={item.id}>
      <td>{i + 1}</td>
      <td>{item.activity}</td>
      <td>{item.activity_date}</td>
    </tr>
  )

  return (
    <section className="dash-alert-details">
      <nav className="mb-4">
        <ol className="breadcrumb alert-breadcrumb">
          <li className="breadcrumb-item"><a style={{ color: 'rgb(30, 144, 255)' }} onClick={() => updateRoutePage('admn-alerts')}>Admission Alerts</a></li>
          <li className="breadcrumb-item active" aria-current="page">{data.institution_name}</li>
        </ol>
      </nav>

      <div className="row">
        <div className="col-lg-3 mb-3">
          <div className="nav flex-column nav-pills alert-tab" id="v-pills-tab" role="tablist" aria-orientation="vertical">
            <a className="nav-link active" id="v-pills-home-tab" data-toggle="pill" href="#info" role="tab">General Information</a>
            <a className="nav-link" id="v-pills-home-tab" data-toggle="pill" href="#offerings" role="tab">Courses Offered</a>
            <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#process" role="tab">Application Process</a>
            <a className="nav-link" id="v-pills-profile-tab" data-toggle="pill" href="#eligible" role="tab">Eligibility</a>
            <a className={`nav-link ${!data.entrance_test_pattern && 'd-none'}`} id="v-pills-messages-tab" data-toggle="pill" href="#pattern" role="tab">Entrance test pattern</a>
            <a className="nav-link" id="v-pills-settings-tab" data-toggle="pill" href="#dates" role="tab">Key Dates</a>
            <a className={`nav-link ${!data.important_link && 'd-none'}`} id="v-pills-settings-tab" data-toggle="pill" href="#links" role="tab">Important Links</a>
          </div>
        </div>
        <div className="col-lg-9 pl-lg-0">
          <div className="tab-content alert-tab-content" id="v-pills-tabContent">
            <div className="tab-pane fade show active" id="info">
              {data.description ? <div dangerouslySetInnerHTML={createMarkup(data.description)}></div> : ""}
            </div>
            <div className="tab-pane fade show" id="offerings">
              {data.programs_offered ? <div dangerouslySetInnerHTML={createMarkup(data.programs_offered)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="process">
              {data.admission_process ? <div dangerouslySetInnerHTML={createMarkup(data.admission_process)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="eligible">
              {data.eligibility ? <div dangerouslySetInnerHTML={createMarkup(data.eligibility)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="pattern">
              {data.entrance_test_pattern ? <div dangerouslySetInnerHTML={createMarkup(data.entrance_test_pattern)}></div> : ""}
            </div>
            <div className="tab-pane fade" id="dates">
              <table className="table table-responsive alert-table">
                <thead>
                  <tr>
                    <th scope="col">#</th>
                    <th scope="col">Key Event</th>
                    <th scope="col">Date</th>
                  </tr>
                </thead>
                <tbody>
                  {listItems}
                </tbody>
              </table>
            </div>
            <div className="tab-pane fade" id="links">
              {data.important_link ? <div dangerouslySetInnerHTML={createMarkup(data.important_link)}></div> : ""}
            </div>
          </div>
        </div>
      </div>
    </section>
  )

}

export default AdminAdmissionAlertDetails



/** WEBPACK FOOTER **
 ** ./src/components/Admin/AdminAdmissionAlerts/AdminAdmissionAlertDetails/index.js
 **/